export default "__VITE_ASSET__0noRQOH4__"